<template>
  <div class="modal" :class="{ 'modal--open': isOpen }">
    <sanitas-button primary class="modal__trigger" @click="open">
      {{ label }}
    </sanitas-button>
    <transition name="fade">
      <div v-if="isOpen">
        <div class="modal__container">
          <div class="modal__full-screen-background" @click="close" />
          <div class="modal__content">
            <slot />
          </div>
          <div class="modal__close" @click="close">
            <dotcom-icon name="xmark" art="light" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SanitasButton from '@/components/sanitas-components/SanitasButton'

import { useFixedOverlay } from '../../../composables/useFixedOverlay'

export default {
  name: 'Modal',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    SanitasButton,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { open, close, isOpen } = useFixedOverlay()
    return { open, close, isOpen }
  },
}
</script>

<style lang="postcss" scoped>
.modal {
  position: relative;
}

.modal--open {
  z-index: var(--z-index-overlay);
}

.modal__content,
.modal__close {
  z-index: calc(var(--z-index-0) + 1);
}

.modal__content {
  position: relative;
}

.modal__close {
  position: absolute;
  right: var(--spacing-4);
  top: var(--spacing-4);
  cursor: pointer;
  padding: var(--spacing-4);
  color: var(--c-primary-color-3);

  &:hover {
    color: var(--c-tint-color-1);
  }

  & >>> .dotcom-icon {
    font-size: 12px;
  }
}

.modal__full-screen-background,
.modal__container {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.modal__full-screen-background {
  background-color: var(--c-primary-neutral-3);
  opacity: 0.75;
}

.modal__container {
  height: 100%;
  width: 100%;
  margin: auto;
  z-index: var(--z-index-overlay);
  overflow-y: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
  z-index: var(--z-index-overlay);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  z-index: var(--z-index-overlay);
}

@media (--md) {
  .modal__close {
    right: var(--spacing-4);
  }

  .modal__container {
    width: calc(100vw - 2 * var(--body-offset-horizontal));
    max-height: 820px;
    max-width: 940px;
  }
}
</style>
